import _ from 'lodash';
import useRaInputsSetting from './settings/hooks/useRaInputsSetting';
import {
  generateResourceTypeFromAdditionalType,
  getLabelsResourceTypeByPmProvider,
  getResourceTypesByPmSensorId,
  RA_ADDITIONAL_TYPES,
  RESOURCE_TYPES
} from './resource_types';
import { useSelector } from 'react-redux';
import { pmToolSensorIdSelector } from 'state/selectors/sensors-authorizations';
import useResourceTypesTreeHierarchy from './useResourceTypesTreeHierarchy';

const useResourceTypes = ({ withExcluded = false } = {}) => {
  const pmProvider = useSelector(pmToolSensorIdSelector);
  const raInputsSetting = useRaInputsSetting();
  const { excludedTypes, additionalTypes, getLabelsFlatten } = raInputsSetting;
  const resourceTypes = { ...RESOURCE_TYPES };

  const labelsResourceType = getLabelsResourceTypeByPmProvider(pmProvider);
  labelsResourceType.setExtraParams(getLabelsFlatten());
  resourceTypes[labelsResourceType.key] = labelsResourceType;

  const additionalTypesByType = _.groupBy(additionalTypes, 'type');
  const additionalCustomFields = _.reduce(
    additionalTypesByType[RA_ADDITIONAL_TYPES.CUSTOM_FIELD],
    (acc, additionalType) => ({
      ...acc,
      [additionalType.id]: generateResourceTypeFromAdditionalType({
        additionalType,
        pmProvider
      })
    }),
    {}
  );

  const resourceTypesWithCustomFields = {
    ...resourceTypes,
    ...additionalCustomFields
  };

  const resourceTypesByPmTool = getResourceTypesByPmSensorId(
    resourceTypesWithCustomFields,
    pmProvider
  );

  const [resourceTypesWithTreeHierarchy, isLoadingIssueTypes] =
    useResourceTypesTreeHierarchy(resourceTypesByPmTool);

  const resourceTypesWithoutExcluded = _.omit(
    resourceTypesWithTreeHierarchy,
    withExcluded ? [] : excludedTypes
  );

  return {
    resourceTypes: resourceTypesWithoutExcluded,
    isLoading: isLoadingIssueTypes
  };
};

export default useResourceTypes;
